/*
 *   File : create.js
 *   Author : https://evoqins.com
 *   Description : Create push notification page
 *   Integrations : 'react-toastify'
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap/dist/js/bootstrap.min';

// custom components
import { CustomDataTable } from '../../Components/DataTable';
import { PrimaryButton } from '../../Components/Buttons';
import { PreviewModal, ResendNotificationModal } from '../../Components/Modal';
import { APIService } from '../../Service';
import { EmptyScreen } from '../../Components/Others';


const PushNotifications = () => {

  const navigate = useNavigate();
  const isRendered = useRef(true);
  const [view, setView] = useState(false);
  const [notificationList, setNotificationList] = useState({});
  const [rowData, setRowData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [onPaginationChange, setOnPaginationChange] = useState(false);

  const [notificationId, setNotificationId] = useState(null);

  useEffect(() => {
    if (view === true) {
      const preview_modal = new Modal(document.getElementById('preview-modal'));
      preview_modal.show();
    }
  }, [view]);

  useEffect(() => {
    if (notificationId !== null) {
      const resend_notification_modal = new Modal(document.getElementById('resend-notification-modal'));
      resend_notification_modal.show();
    }
  }, [notificationId]);

  useEffect(() => {
    window.scrollTo({
      top: 0, behavior: 'smooth'
    });
  }, []);


  useEffect(() => {
    if (isRendered.current === true) {
      _notificationList();
    }
    isRendered.current = false;
  }, []);

  const _handleNavigate = () => {
    navigate("manage")
  };

  const _handleView = (row) => {
    setRowData(row);
    setView(true);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0, behavior: 'smooth'
    });
  }, [currentPage]);


  // handle table page change 
  const _handleTablePageChange = (page_num) => {
    setCurrentPage(page_num);
    _notificationList(page_num);
  };

  // re-balance history data table column 
  const INVESTMENT_TABLE_COLUMN = [
    {
      name: 'Notification title',
      selector: row => row.title,
      cell: row => <>{row.title}</>,
      width: "300px"
    },
    {
      name: 'Target users',
      selector: row => row.target_users,
      cell: row => <>{row.target_users}</>,
      width: "260px"
    },
    {
      name: 'Triggered by',
      selector: row => row.name || "-",
      cell: row => <>{row.name || "-"}</>,
      width: "180px"
    },
    {
      name: 'Sent date & time',
      cell: (row) => row.created,
      width: "200px"
    },
    {
      // name: 'View',
      cell: (row) =>
        <div className='e-hover cursor-pointer e-primary-font e-text-blue-violet e-font-weight-600 line-height-24px e-font-14'
          onClick={() => _handleView(row)}>View</div>,
      width: "80px"
    },
    {
      // name: 'View',
      cell: (row) =>
        <div className='e-hover cursor-pointer e-primary-font e-text-blue-violet e-font-weight-600 line-height-24px e-font-14'
          onClick={() => setNotificationId(row.notification_id)}>Resend</div>,
      width: "100px"
    },
  ];


  // API - Notification list 
  const _notificationList = (page_num = currentPage) => {
    let is_post = true;
    let url = 'notification/list';
    let request = {
      "page_num": page_num,
      "page_size": 10
    }
    APIService(is_post, url, request).then((response) => {
      if (response.status_code === 200) {
        setNotificationList(response.data);
      } else {
        setNotificationList({ data: [] });
      }
      setLoader(false);
      setOnPaginationChange(false);
    })
  };

  return (

    <div>
      <section className='e-section-height pb-5' >
        <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
          <p className='mb-0 e-font-weight-600 e-text-chinese-black e-primary-font e-font-24 e-font-weight-400 line-height-24px'>
            Push Notifications
          </p>
        </div>

        <div className='padding-52px-lr margin--80px-top'>
          {/* Investment history  */}
          <div className='e-bg-white border-radius-16 '>
            <div className='padding-32px-lr padding-32px-top d-flex align-items-center justify-content-between'>
              <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                Notification list
              </h4>
              <PrimaryButton name='Create Notification'
                paddingBlock='padding-12px-tb padding-16px-lr'
                onClick={_handleNavigate} />
            </div>
            {/*  Investment  table h-584px */}

            {loader ?
              <div className='d-flex align-items-center justify-content-center py-4 min-vh-50 '>
                <img src={require("../../Assets/Image/loader.gif")}
                  draggable={false}
                  width={80}
                  height={80}
                  alt='loader'
                  className='text-center' />
              </div>
              :
              notificationList.data.length !== 0 ?
                <div className='e-data-table-wrapper-default-updated py-4 '>
                  <CustomDataTable columns={INVESTMENT_TABLE_COLUMN}
                    data={notificationList.data}
                    pagination={true}
                    paginationPerPage={10}
                    lastPage={notificationList.total_page}
                    paginationDefaultPage={notificationList.current_page}
                    paginationTotalRows={notificationList.total_count}
                    onChangePage={_handleTablePageChange}
                  />
                </div>
                :
                <EmptyScreen
                  image={require('../../Assets/Image/NotFound/no-data.png')}
                  title='No results found'
                  description={`We couldn' t find anything that matches your search. Try checking your spelling, using different keywords, or exploring popular funds.`}
                />
            }
          </div>
        </div>
      </section>


      {view === true &&
        <PreviewModal type={1}
          data={rowData}
          title="View notification"
          handleClose={() => {
            setTimeout(() => {
              setView(false)
            }, 200);
          }}
        />
      }

      {notificationId !== null &&
        <ResendNotificationModal
          notificationId={notificationId}
          handleClose={() => {
            setTimeout(() => {
              setNotificationId(null);
            }, 200);
          }}
        />
      }


    </div>
  )
}

export default PushNotifications;
